import ClienteEmailService from "@/services/ClienteEmailService";

export const clienteEmail = {
  namespaced: true,
  state: {
    clienteEmail: {},
  },
  actions: {
    getClienteEmail({ commit }, payload) {
      return ClienteEmailService.GetClienteEmail(payload).then(
        (clienteEmail) => {
          return Promise.resolve(clienteEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postClienteEmail({ commit }, payload) {
      return ClienteEmailService.PostClienteEmail(payload).then(
        (clienteEmail) => {
          return Promise.resolve(clienteEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putClienteEmail({ commit }, payload) {
      return ClienteEmailService.PutClienteEmail(payload).then(
        (clienteEmail) => {
          return Promise.resolve(clienteEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteClienteEmail({ commit }, payload) {
      return ClienteEmailService.DeleteClienteEmail(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getClienteEmailOData({ commit }, payload) {
      return ClienteEmailService.GetClienteEmailOData(payload).then(
        (clienteEmail) => {
          return Promise.resolve(clienteEmail);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default clienteEmail;
